
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'OverlarContainer',
  setup () {
    return {
      progressArg: '{ "progress": 0 }'
    }
  }
})
